import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { AddOutlined } from '@mui/icons-material';

interface AddEncounterButtonProps {
  company: string;
  center: string;
  mrn?: string;
}

const AddEncounterButton: React.FC<AddEncounterButtonProps> = ({ company, center, mrn }) => {
  const navigate = useNavigate();

  const handleAddEncounter = () => {
    const params = new URLSearchParams({
      company,
      selectedCenter: center,
      ...(mrn && { mrn })
    });
    navigate(`/EncounterCreate?${params.toString()}`);
  };

  return (
    <Button
      variant="contained"
      startIcon={<AddOutlined />}
      onClick={handleAddEncounter}
      sx={{
        backgroundColor: '#162346',
        color: 'white',
        fontWeight: 600,
        '&:hover': {
          backgroundColor: '#1a2a52'
        }
      }}
    >
      Add Encounter
    </Button>
  );
};

export default AddEncounterButton;
